import ProductSelect from './productSelect.container';

export default ProductSelect;
